import { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
} from "@mui/material";
import logo from "../img/logo.png";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

export default function Header({ userEmail }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    console.log("Logout");
    handleMenuClose();
  };

  return (
    <AppBar position="static" >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        {/* Logotipo e título */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <img src={logo} alt="Logotipo" style={{ height: 50, marginRight: 12 }} />
          <Typography variant="h6" component="div">
            SONIVANDO
          </Typography>
        </Box>

        {/* Menu de usuário */}
        <Box>
          <IconButton onClick={handleMenuOpen} color="inherit">
            <AccountCircleIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem disabled>{userEmail || "Usuário"}</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
